import React, { useEffect, useState } from "react";
import { StateLoadingDialog } from "./state-loading-dialog/StateLoadingDialog";
import { StateCard } from "./StateCard";
import { StateUIProvider } from "./StateUIContext";
import { StateEditModal } from "./state-edit-modal/StateEditModal";
import { StateDeleteModal } from "./state-delete-modal/StateDeleteModal";
import {
  addStateApi,
  countryListAllApi,
  deleteStateApi,
  editStateApi,
  stateListApi,
} from "../../../axios/services/services";
import UpdatedSuccessfulModal from "../Modal/UpdatedSuccessfulModal";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import ErrorModal from "../Modal/ErrorModal";
import SVG from "react-inlinesvg";
import AddNewStateModal from "../Modal/AddNewStateModal";
import {
  AddStateSchema,
  EditStateSchema,
} from "../../FormikSchema/FormikSchema";
import { useFormik } from "formik";
import { initialFilter } from "./StateUIHelpers";
import { isUnauthorized, trimmer } from "../../utils/utils";

const AddStateInitialValues = {
  state_name: "",
  state_code: "",
  status: "1",
  countryname: "",
};

const EditStateInitialValues = {
  state_name: "",
  state_code: "",
  status: "1",
  countryname: "",
};

export function StatePage({ history }) {
  const [isLoadingAddNewState, setLoadingAddNewState] = useState(false);
  const [isLoadingEditState, setLoadingEditState] = useState(false);
  const [isLoadingDeleteState, setLoadingDeleteState] = useState(false);
  const [isAddNewStateModal, setAddNewStateModal] = useState(false);
  const [data, setData] = useState({});
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [isEditModal, setEditModal] = useState(false);
  const [stateList, setStateList] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [isUpdateStateDetails, setUpdateStateDetails] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [stateListTotalCount, setStateListTotalCount] = useState(0);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);

  useEffect(() => {
    async function getStateList() {
      enableLoading();
      const stateListResponse = await stateListApi({
        filterValues,
        queryParams,
        isActiveOnly: 0,
      });
      disableLoading();
      if (stateListResponse.Error) {
        isUnauthorized({ response: stateListResponse });
        setErrorMessage(stateListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setStateListTotalCount(
        stateListResponse && stateListResponse.count
          ? stateListResponse.count
          : 0
      );
      setStateList(
        stateListResponse && stateListResponse.data
          ? stateListResponse.data
          : []
      );
    }
    getStateList();
  }, [filterValues, isUpdateStateDetails, queryParams]);

  useEffect(() => {
    async function getCountryList() {
      const countryListResponse = await countryListAllApi({ isActiveOnly: 1 });
      if (countryListResponse.Error) {
        isUnauthorized({ response: countryListResponse });
        setErrorMessage(countryListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setCountryList(
        countryListResponse && countryListResponse.data
          ? countryListResponse.data
          : []
      );
    }
    getCountryList();
  }, []);

  const handleAddNewStateModalShow = () => {
    setAddNewStateModal(true);
  };

  const handleAddNewStateModalHide = () => {
    setAddNewStateModal(false);
  };

  const stateUIEvents = {
    openDeleteDialog: (row) => {
      setData(row);
      handleDeleteShow();
    },
    openEditDialog: (row) => {
      setData(row);
      const { state_name, state_code, status, countryId } = row;
      const { name } = countryId || {};
      formikEditState.setFieldValue("state_name", state_name);
      formikEditState.setFieldValue("state_code", state_code);
      formikEditState.setFieldValue("countryname", name);
      formikEditState.setFieldValue("status", status ? "1" : "0");
      handleEditShow();
    },
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const enableLoadingDeleteState = () => {
    setLoadingDeleteState(true);
  };

  const disableLoadingDeleteState = () => {
    setLoadingDeleteState(false);
  };

  const enableLoadingAddState = () => {
    setLoadingAddNewState(true);
  };

  const disableLoadingAddState = () => {
    setLoadingAddNewState(false);
  };

  const enableLoadingEditState = () => {
    setLoadingEditState(true);
  };

  const disableLoadingEditState = () => {
    setLoadingEditState(false);
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  const handleDeleteShow = () => {
    setDeleteModal(true);
  };

  const handleDeleteHide = () => {
    setDeleteModal(false);
  };

  const handleEditShow = () => {
    setEditModal(true);
  };

  const handleEditHide = () => {
    setEditModal(false);
  };

  const handleSuccessModalShow = () => {
    setIsSuccessModalOpen(true);
  };

  const handleSuccessModalHide = () => {
    setIsSuccessModalOpen(false);
  };

  const handleFilterValues = (values) => {
    setFilterValues(values);
  };

  const formikAddState = useFormik({
    initialValues: AddStateInitialValues,
    validationSchema: AddStateSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      addNewState(values, setSubmitting);
    },
    onReset: (values, { resetForm }) => {},
  });

  const formikEditState = useFormik({
    initialValues: EditStateInitialValues,
    validationSchema: EditStateSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      editState(values, setSubmitting);
    },
    onReset: (values, { resetForm }) => {},
  });

  const handleAddNewState = () => {
    if (countryList && countryList.length > 0) {
      const [country] = countryList;
      formikAddState.setFieldValue("countryname", country.name);
    }
    handleAddNewStateModalShow();
  };

  const handleOnClickOfAddNewStateCancelButton = () => {
    formikAddState.handleReset();
    handleAddNewStateModalHide();
  };

  const handleOnClickOfEditModalCancelButton = () => {
    formikEditState.handleReset();
    handleEditHide();
  };

  const handleOnClickOfDeleteStateButton = () => {
    deleteState();
  };

  const handleSetCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const addNewState = async (values, setSubmitting) => {
    const { state_name, state_code, countryname, status } = values;
    const [country] = countryList.filter(
      (country) => country.name === countryname
    );
    const { id } = country;
    let addStateObj = {
      state_name: state_name,
      state_code: state_code,
      country_id: id,
      status: parseInt(status) === 1 ? true : false,
    };
    enableLoadingAddState();
    const addStateResponse = await addStateApi(trimmer(addStateObj));
    disableLoadingAddState();
    setSubmitting(false);
    if (addStateResponse.Error) {
      isUnauthorized({ response: addStateResponse });
      setErrorMessage(addStateResponse.Error.message);
      handleErrorModalShow();
      return;
    }
    formikAddState.handleReset();
    setSuccessMessage("State Added Successfully");
    handleAddNewStateModalHide();
    setUpdateStateDetails(Math.random());
    handleSuccessModalShow();
  };

  const editState = async (values, setSubmitting) => {
    const { id } = data;
    const { state_name, state_code, countryname, status } = values;
    const [country] = countryList.filter(
      (country) => country.name === countryname
    );
    const { id: countryId } = country;
    let editStateObj = {
      id,
      state_name: state_name,
      state_code: state_code,
      country_id: countryId,
      status: status === "1" ? true : false,
    };
    enableLoadingEditState();
    setSubmitting(true);
    const editStateResponse = await editStateApi(trimmer(editStateObj));
    disableLoadingEditState();
    setSubmitting(false);
    if (editStateResponse.Error) {
      isUnauthorized({ response: editStateResponse });
      setErrorMessage(editStateResponse.Error.message);
      handleErrorModalShow();
      return;
    }
    setSuccessMessage("State Edited Successfully ");
    handleSuccessModalShow();
    setUpdateStateDetails(Math.random());
    handleEditHide();
  };

  const deleteState = async () => {
    const { id, state_name } = data;
    enableLoadingDeleteState();
    const deleteStateResponse = await deleteStateApi({ id });
    disableLoadingDeleteState();
    if (deleteStateResponse.Error) {
      isUnauthorized({ response: deleteStateResponse });
      setErrorMessage(deleteStateResponse.Error.message);
      handleErrorModalShow();

      return;
    }
    setSuccessMessage(`${state_name} State Deleted Successfully`);
    handleSuccessModalShow();
    setUpdateStateDetails(Math.random());
    handleDeleteHide();
  };

  return (
    <>
      <StateUIProvider
        stateUIEvents={stateUIEvents}
        queryParams={queryParams}
        setQueryParamsBase={setQueryParamsBase}
        ids={ids}
        setIds={setIds}
      >
        <StateLoadingDialog />
        {isAddNewStateModal && (
          <AddNewStateModal
            isLoadingAddNewState={isLoadingAddNewState}
            countryList={countryList}
            isAddNewStateModal={isAddNewStateModal}
            handleAddNewStateHide={handleAddNewStateModalHide}
            formik={formikAddState}
            handleOnClickOfAddNewStateCancelButton={
              handleOnClickOfAddNewStateCancelButton
            }
          />
        )}

        {isDeleteModal && (
          <StateDeleteModal
            isLoadingDeleteState={isLoadingDeleteState}
            data={data}
            handleDeleteHide={handleDeleteHide}
            isDeleteModal={isDeleteModal}
            handleOnClickOfDeleteStateButton={handleOnClickOfDeleteStateButton}
          />
        )}
        {isEditModal && (
          <StateEditModal
            isLoadingEditState={isLoadingEditState}
            data={data}
            handleEditHide={handleEditHide}
            isEditModal={isEditModal}
            formikEditState={formikEditState}
            countryList={countryList}
            handleOnClickOfEditModalCancelButton={
              handleOnClickOfEditModalCancelButton
            }
          />
        )}

        <StateCard
          isLoading={isLoading}
          stateList={stateList}
          countryList={countryList}
          filterValues={filterValues}
          currentPage={currentPage}
          setCurrentPage={handleSetCurrentPage}
          stateListTotalCount={stateListTotalCount}
          handleAddNewState={handleAddNewState}
          handleFilterValues={handleFilterValues}
        />

        <UpdatedSuccessfulModal
          message={successMessage}
          UpdatedSuccessfulModalShow={isSuccessModalOpen}
          UpdatedSuccessfulModalHide={handleSuccessModalHide}
          successIcon={
            <div className="success-icon-wrapper text-center">
              <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                />
              </span>
            </div>
          }
        />

        <ErrorModal
          message={errorMessage}
          isErrorModalOpen={isErrorModalOpen}
          hideErrorModal={handleErrorModalHide}
          errorIcon={
            <div className="danger-icon-wrapper text-center">
              <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
                />
              </span>
            </div>
          }
          errorButtonLabel={"Close"}
          errorOnClick={handleErrorModalHide}
        />
      </StateUIProvider>
    </>
  );
}
